import ApiService from "../ApiService";

const AllDispenzation = {
  getPrescriptionDetail(prescriptionNumber,) {
    return ApiService.get(
      `/prescription/get-prescription-order?prescriptionNumber=${prescriptionNumber} `
    );
  },
  saveDispensePrescription(data,) {
    return ApiService.post("/prescription/dispence-prescription", data);
  },
  getConsultPrescription(page, rowsPerPage, search, status, providerId, date, date2, searchType) {
   
    providerId = providerId || '';
    return ApiService.get(
        `/prescription/search-dosifications?page=${page}&perPage=${rowsPerPage}&searchString=${search}&orderStatus=${status}&providerId=${providerId}&dateAfter=${date}&dateBefore=${date2}&searchType=${searchType}`
    );
},
getConsultDui( dui, birthdate,) {
  return ApiService.get(
    `prescription/validate-dui?birthdate=${birthdate}&dui=${dui} `
  );
},
getConsultDocument( dui, birthdate,typeDocument) {
  return ApiService.get(
    `prescription/validate-document?numberDocument=${dui}&birthdate=${birthdate}&typeDocument=${typeDocument}`
  );
},

updateLaboratoryUpdateStudy(data,) {
  return ApiService.post("/integrations/update-study", data);
},
updateLaboratoryUpdateStudyStatus(data,) {
  return ApiService.post("/integrations/update-study-status", data);
},
getLaboratory( studyNumber) {
  return ApiService.get(
    `integrations/get-laboratory?studyNumber=${studyNumber}`
  );
},
getStudyRx( studyNumber) {
  return ApiService.get(
    `integrations/get-study-rx?studyNumber=${studyNumber}`
  );
},
getConsultLab(page, rowsPerPage, search, status, providerId, date, date2, searchType) {
   
  providerId = providerId || '';
  return ApiService.get(
      `integrations/search-study-update?dateBefore=${date2}&dateAfter=${date}&perPage=${rowsPerPage}&page=${page}&searchType=${searchType}&searchString=${search}`
  );
},
};

export default AllDispenzation;